import { schema } from "normalizr";
import wevoSegmentSchema from "./wevo-audience-segment";
import imageSchema from "./image";
import { WEVO_AUDIENCE_DELIMITER } from "../modules/audiences/constants";

const wevoAudienceSchema = new schema.Entity(
    "wevoAudiences",
    {
        segments: [wevoSegmentSchema],
        iconImage: imageSchema
    },
    {
        idAttribute: (value, parent) => {
            return [parent.id, value.id].join(WEVO_AUDIENCE_DELIMITER);
        }
    }
);

export default wevoAudienceSchema;



// WEBPACK FOOTER //
// ./src/schemas/wevo-audience.js